import { Button, OnDeckLogo } from '@odmonorepo/core-components';
import { Stack } from 'react-bootstrap';
import { Link, useRouter } from '@tanstack/react-router';
import { useParties } from 'merchant-api/spiceroad';
import { queryClient, unifiedApiClient } from 'merchant-api';
import { useMutation } from '@tanstack/react-query';

export interface HeaderProps {
  fullName: string | never;
  businessName: string | never;
}

export function Header() {
  const { partiesData } = useParties();
  const router = useRouter();
  const { mutate: logout } = useMutation({
    throwOnError: false,
    mutationFn: () => unifiedApiClient.POST('/public/token/logout'),
    onSuccess: () => {
      // Drop the whole query cache, not just the signed-in gate: any cached query (current
      // application, offers, loan state) would otherwise survive into the next sign-in and
      // render the previous user's data for up to a staleTime.
      queryClient.clear();
      router.navigate({ to: '/' });
    },
    onSettled: () => router.invalidate({sync: true})
  });

  const merchantName =
    partiesData?.parties?.[0]?.people?.[0]?.name || undefined;
  const businessName =
    partiesData?.parties?.[0]?.businesses?.[0]?.legalName || undefined;

  return (
    <Stack direction="horizontal">
      <Link to="/">
        <OnDeckLogo width="150px" className="mb-4" />
      </Link>
      <div className="ms-auto">
        <Stack className="align-items-end ms-auto">
          {merchantName && businessName && (
            <>
              <div className="fs-6 fw-bold">
                <Stack className="text-decoration-none mt-3">
                  {merchantName}
                </Stack>
                </div>
                <div className="fs-8">
                <Stack className="text-decoration-none">{businessName}</Stack>
                </div>
            </>
          )}
          <Button
            className={`fw-bold ${merchantName ? 'fs-6 p-0' : 'fs-5 p-0'} `}
            variant="link"
            onClick={() => logout()}
          >
            Sign Out
          </Button>
        </Stack>
      </div>
    </Stack>
  );
}

export default Header;
